/* ============================================================
   BONLIFE MENA — Product page interactivity
   Variant selection, gallery switching, quantity, sticky buy.
   Reads variant data from a JSON <script> embedded by the
   main-product section. Falls back gracefully if absent.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-product]');
  if (!root) return;

  var dataEl = root.querySelector('[data-product-json]');
  var product = {};
  try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var optionSelectors = root.querySelectorAll('[data-option-index]');
  var variantIdInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-price]');
  var addBtn = root.querySelector('[data-add-btn]');
  var addBtnText = root.querySelector('[data-add-btn-text]');
  var stickyBtn = root.querySelector('[data-sticky-add]');
  var stickyPrice = root.querySelector('[data-sticky-price]');
  var moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';
  var currency = root.getAttribute('data-currency') || '';
  var colourIndex = parseInt(root.getAttribute('data-colour-index'), 10);

  /* declared before render() so the colour filter can reach them */
  var thumbs = root.querySelectorAll('[data-thumb]');
  var slides = root.querySelectorAll('[data-slide]');
  var stockBadge = root.querySelector('[data-stock-badge]');
  var prevBtn = root.querySelector('[data-gallery-prev]');
  var nextBtn = root.querySelector('[data-gallery-next]');

  function formatMoney(cents) {
    var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (currency ? currency + ' ' : '') + amount;
  }

  function getSelectedOptions() {
    var selected = [];
    optionSelectors.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var active = group.querySelector('[data-value].is-active') || group.querySelector('input:checked');
      if (active) selected[idx] = active.getAttribute('data-value') || active.value;
    });
    return selected;
  }

  function findVariant(selected) {
    return (product.variants || []).find(function (v) {
      return v.options.every(function (opt, i) { return !selected[i] || opt === selected[i]; });
    });
  }

  function updateValueLabel(group) {
    var label = group.parentElement.querySelector('[data-option-value-label]');
    var active = group.querySelector('[data-value].is-active');
    if (label && active) label.textContent = active.getAttribute('data-value');
  }

  /* Show only the selected colour's media. Images are tagged in the section
     from their alt text or filename; anything untagged is "all" and always
     shows. If no media carries the selected colour the gallery is left
     untouched, which is how products that predate the naming convention
     keep working. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Pause whatever scrolled out of view, start whatever came into it. The
     video is rendered muted, which is what lets a browser honour play() at
     all; muted is not forced here, so an unmute survives switching away and
     back. */
  function syncVideoPlayback() {
    root.querySelectorAll('.gallery__video video').forEach(function (video) {
      var slide = video.closest('[data-slide]');
      if (!slide) return;
      if (slide.classList.contains('is-active')) {
        if (reduceMotion) return;
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  /* Stepping walks only the slides currently on screen. A product can hold 16
     media items while the selected colour shows 4, so indices from the Liquid
     loop are not positions in what the customer can actually page through. */
  function visibleSlides() {
    return Array.prototype.filter.call(slides, function (s) { return !s.hidden; });
  }

  function activateSlide(index) {
    slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === index); });
    thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === index); });
    syncVideoPlayback();

    /* keep the active thumbnail in view in the horizontal strip on mobile.
       Scrolling the strip directly rather than scrollIntoView, which would
       also scroll the page. */
    var strip = root.querySelector('.gallery__thumbs');
    var active = root.querySelector('[data-thumb="' + index + '"]');
    if (strip && active && strip.scrollWidth > strip.clientWidth) {
      strip.scrollLeft = active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2;
    }
  }

  function stepSlide(delta) {
    var visible = visibleSlides();
    if (visible.length < 2) return;
    var current = 0;
    visible.forEach(function (s, i) { if (s.classList.contains('is-active')) current = i; });
    var next = (current + delta + visible.length) % visible.length;
    activateSlide(visible[next].getAttribute('data-slide'));
  }

  function syncGalleryNav() {
    var many = visibleSlides().length > 1;
    if (prevBtn) prevBtn.hidden = !many;
    if (nextBtn) nextBtn.hidden = !many;
  }

  /* Sold out first, then low stock, then nothing. One slot, so two states can
     never stack. Only tracked variants on a deny policy can be counted: an
     untracked one reports 0, and a continue policy keeps selling past 0, so
     both would otherwise read as sold out. */
  function updateStockBadge(variant) {
    if (!stockBadge) return;
    var threshold = parseInt(stockBadge.getAttribute('data-low-threshold'), 10) || 0;
    var text = '';
    var state = '';

    if (variant && !variant.available) {
      text = stockBadge.getAttribute('data-soldout-text') || 'Sold out';
      state = 'is-sold-out';
    } else if (
      variant && variant.tracked && variant.policy === 'deny' &&
      variant.inventory > 0 && variant.inventory <= threshold
    ) {
      text = (stockBadge.getAttribute('data-low-text') || 'Only [count] left')
        .replace('[count]', variant.inventory);
      state = 'is-low';
    }

    stockBadge.textContent = text;
    stockBadge.classList.remove('is-sold-out', 'is-low');
    if (state) stockBadge.classList.add(state);
    stockBadge.hidden = text === '';
  }

  function groupKey(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, '-');
  }

  function filterMediaByColour() {
    if (isNaN(colourIndex) || colourIndex < 0 || !slides.length) return;
    var key = groupKey(getSelectedOptions()[colourIndex]);
    if (!key || !root.querySelector('[data-media-group="' + key + '"]')) return;

    var firstVisible = null;
    slides.forEach(function (slide) {
      var group = slide.getAttribute('data-media-group');
      var show = group === key || group === 'all';
      slide.hidden = !show;
      if (show && firstVisible === null) firstVisible = slide.getAttribute('data-slide');
    });
    thumbs.forEach(function (thumb) {
      var group = thumb.getAttribute('data-media-group');
      thumb.hidden = !(group === key || group === 'all');
    });
    syncGalleryNav();
    if (firstVisible === null) return;
    activateSlide(firstVisible);
  }

  function render() {
    filterMediaByColour();
    syncVideoPlayback();
    var selected = getSelectedOptions();
    var variant = findVariant(selected);
    updateStockBadge(variant);
    if (!variant) {
      if (addBtn) { addBtn.disabled = true; if (addBtnText) addBtnText.textContent = 'Unavailable'; }
      return;
    }
    if (variantIdInput) variantIdInput.value = variant.id;

    var priceHtml = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceHtml += ' <span class="old">' + formatMoney(variant.compare_at_price) + '</span>';
    }
    if (priceEl) priceEl.innerHTML = priceHtml;
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (addBtnText) addBtnText.textContent = variant.available ? ('Add to bag — ' + formatMoney(variant.price)) : 'Sold out';
    }
    if (stickyBtn) stickyBtn.disabled = !variant.available;

    // update URL for shareable variant
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  }

  // swatch / size button clicks
  optionSelectors.forEach(function (group) {
    group.querySelectorAll('[data-value]').forEach(function (btn) {
      if (btn.classList.contains('is-out')) return;
      btn.addEventListener('click', function () {
        group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        updateValueLabel(group);
        render();
      });
    });
    // native select fallback
    var sel = group.querySelector('select');
    if (sel) sel.addEventListener('change', render);
  });

  /* ---- Gallery arrows and swipe ---- */
  if (prevBtn) prevBtn.addEventListener('click', function () { stepSlide(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { stepSlide(1); });

  var mainStage = root.querySelector('.gallery__main');
  if (mainStage) {
    var touchStartX = null;
    var touchStartY = null;

    mainStage.addEventListener('touchstart', function (e) {
      /* a swipe that starts on a video is the player's own - scrubbing,
         volume - so leave it alone */
      if (e.target.closest && e.target.closest('video')) { touchStartX = null; return; }
      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
    }, { passive: true });

    mainStage.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      touchStartX = null;
      /* ignore anything more vertical than horizontal, so scrolling the page
         past the gallery does not flip the image */
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      stepSlide(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  syncGalleryNav();

  /* ---- Gallery thumbnail switching ---- */
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      activateSlide(t.getAttribute('data-thumb'));
    });
  });

  /* ---- Quantity stepper ---- */
  var qtyInput = root.querySelector('[data-qty-input]');
  root.querySelectorAll('[data-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!qtyInput) return;
      var v = parseInt(qtyInput.value, 10) || 1;
      v += parseInt(b.getAttribute('data-qty-step'), 10);
      qtyInput.value = Math.max(1, v);
    });
  });

  /* ---- Sticky mobile buy: mirror the main add-to-cart ---- */
  if (stickyBtn && addBtn) {
    stickyBtn.addEventListener('click', function () { addBtn.click(); });
    var bar = root.querySelector('[data-sticky-bar]');
    var anchor = root.querySelector('[data-add-anchor]');
    if (bar && anchor && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky-buy');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('is-enabled', !e.isIntersecting); });
      }, { rootMargin: '0px 0px -60px 0px' });
      io.observe(anchor);
    }
  }

  render();
})();
